import type { AuthUser } from '../../view-model/contexts/auth-context/AuthContextV1';

export function whatsappConsent(
  user: AuthUser | undefined,
): boolean | undefined {
  return user === undefined ? undefined : user.whatsapp_consent;
}

export function requirementType(
  user: AuthUser | undefined,
): string | undefined {
  return user === undefined ? undefined : user.requirement_type;
}
